export default "__VITE_ASSET__0d8bb780__"